export enum Bank {
  MBANK = 'MBANK',
  ING = 'ING',
  NEST_BANK = 'NEST_BANK',
  OTHER_PL = 'OTHER_PL',
}
